import React, { useContext, useEffect, useRef, useState } from 'react'
import './Dashcontents.css'
import farmer from "../../imgs/farmer.png";
import sanghicon from "../../imgs/sangh.png";
import ratib from "../../imgs/ratib.webp";
import newrates from "../../imgs/newrates.png";
import axios from 'axios';
import center from "../../imgs/center.png";
import qr from "../../imgs/QR.png";
import khadya from "../../imgs/khadya.png";
import bank from "../../imgs/bank.png";
import ratetable from "../../imgs/ratetable.png";
import settings from "../../imgs/settings.png";
import Box from '../Box/Box';
import Cowleft from "../../imgs/cowleft.gif";
import Newcustomer from '../Newcustomer/Newcustomer';
import Sangh from '../Sangh/Sangh';
import Newkendra from '../Newkendra/Newkendra';
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog/Dialog';
import Ratetable from '../Ratetable/Ratetable';
import Setting from '../Settings/Settings';
import Nrepair from '../Nrepair/Nrepair';
import Globalcontext from '../../Context/Globalcontext';
import { ToastContainer, toast } from 'react-toastify';
import Ratibmaster from '../Ratibmaster/Ratibmaster';
import Bank from '../Bank/Bank';
import Khparty from '../Khparty/Khparty';
import Kapatmaster from '../Kapatmaster/Kapatmaster';
import Ratetablesangh from '../Ratetablesangh/Ratetablesangh';

import { useTranslation } from "react-i18next";
import LanguageSelector from "../LanguageSelector/LanguageSelector";

const Dashcontendts = (props) => {

    const [mastermenu, setMastermenu] = useState(true);
    const [showBackImage, setShowBackImage] = useState(false);
    const [transitionEnded, setTransitionEnded] = useState(true);
    const [kopen, setkopen] = useState(0);
    const [expirebox, setExpirebox] = useState(false);
    const { submenu, setsubmenu } = useContext(Globalcontext);
    const notify = (msg) => toast(msg);
    const refnewkendra = useRef(null);
    const [daysRemaining, setDaysRemaining] = useState(0);
    const refnewkendraclose = useRef(null);
    const refprint = useRef(null);
    const refprintclose = useRef(null);

    const navigate = useNavigate();
    const { newcustsource, setNewcustsource, kendrasource, setKendrasource, setHeadname, custlist, setCustlist } = useContext(Globalcontext);
    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    // ✅ IMPORTANT: use i18n too (to re-render on language switch)
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (newcustsource === "sank") {
            setShowBackImage(true);
            setMastermenu(false);
            setTransitionEnded(true);
            if (submenu === "customer") {
                setkopen(0);
            }
        }
        //getmyinfo();

        if (localStorage.getItem('contact') === "9975337297") {

            const currentDate = new Date();

            // Target date
            const targetDate = new Date(localStorage.getItem("vdate"));

            // Calculate the difference in milliseconds
            const differenceInTime = targetDate.getTime() - currentDate.getTime();

            // Convert the difference from milliseconds to days
            const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

            // Set the result in state
            setDaysRemaining(differenceInDays);

            if (differenceInDays <= 7) {
                handlePrint();
                setExpirebox(true);
            }
        }
    }, [])


    const areUSure = (choose) => {
        handleDialog("", false);
    };

    const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({
            message,
            isLoading,
            nameProduct
        });
    };

    const showdialog = () => {
        setkopen(1);
        // ✅ translated
        handleDialog(t("dialog.kendra_not_available"), true, t("dialog.create_new_kendra"));
    }

    const openkendra = () => {
        setShowBackImage(true);
        setMastermenu(false);
        setTransitionEnded(true);
        setsubmenu("kendra");
        setkopen(1);
    }

    useEffect(() => {

        if (newcustsource === "sank") {
            setShowBackImage(true);
            setMastermenu(false);
            setTransitionEnded(true);
            if (submenu === "customer") {
                setkopen(0);
            }
        }
        if (kendrasource === "Dashboard" || kendrasource === "Transection") {
            setShowBackImage(true);
            setMastermenu(false);
            setTransitionEnded(true);
            if (submenu === "kendra") {
                setkopen(1);
            }
        }
        if (localStorage.getItem("contact") === "" || localStorage.getItem("contact") === null) {
            navigate("/");
            localStorage.setItem("status", "");
            localStorage.setItem("contact", "");
        }
        // console.log("kendra name- ",localStorage.getItem("kendra"));
        //notify(localStorage.getItem("kendra"));
        if (localStorage.getItem("kendra") === "Not available" && kopen === 0) {
            showdialog();
        }
    })

    const visibility = () => {

        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        // ✅ translated
        setHeadname(t("dash.title"));
    }

    const handleTransitionEnd = () => {
        if (!mastermenu) {
            setShowBackImage(true);
        } else {
            setShowBackImage(false);
        }
        setTransitionEnded(true);
    };

    const handlePrint = () => {
        refprint.current.click();
    }

    function formatDate(inputDate) {
        // Convert the input date string to a Date object
        const date = new Date(inputDate);

        // Define month names
        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr',
            'May', 'Jun', 'Jul', 'Aug',
            'Sep', 'Oct', 'Nov', 'Dec'
        ];

        // Get the day, month, and year
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        // Format the date as 'day Month Year'
        const formattedDate = `${day} ${monthNames[monthIndex]} ${year}`;

        return formattedDate;
    }

    const handleprintclose = () => {
        refprintclose.current.click();
    }

    const logout = (contact) => {
        refnewkendraclose.current.click();
        localStorage.setItem("status", "");
        localStorage.setItem("contact", "");
        localStorage.setItem("contactplant", "");
        localStorage.setItem("kendra", "Not available");
        localStorage.setItem("kmobno", "");
        localStorage.setItem("ksr", "");
        localStorage.setItem("status", "");
        localStorage.setItem("vdate", "");

        localStorage.setItem("name", "");
        localStorage.setItem("city", "");
        localStorage.setItem("tal", "");
        localStorage.setItem("dist", "");
        localStorage.setItem("username", "");
        localStorage.setItem("mobile", "");
        localStorage.setItem("status", "");
        localStorage.setItem("vdate", "");
        localStorage.setItem("bill10type", "");
        localStorage.setItem("plant", "");
        localStorage.setItem("parent", "");
        localStorage.setItem("suchana", "");
        localStorage.setItem("thevper", "");
        localStorage.setItem("dur", "");
        localStorage.setItem("digri", "");

        localStorage.setItem("lastbilldate", "Not available");
        localStorage.setItem("custlist", "");
        localStorage.setItem("mhrates", "");
        localStorage.setItem("gayrates", "");
        localStorage.setItem("treport", "");
        localStorage.setItem("mhrates9", "");
        localStorage.setItem("gayrates9", "");
        localStorage.setItem("sanghlist", "");
        localStorage.setItem("lpoints", "");

        localStorage.setItem("thevregular", "");
        localStorage.setItem("thev1", "");
        localStorage.setItem("thev2", "");
        localStorage.setItem("thev3", "");
        localStorage.setItem("advchalu", "");
        localStorage.setItem("advkapat", "");
        localStorage.setItem("khchalu", "");
        localStorage.setItem("khkapat", "");
        localStorage.setItem("ratibchalu", "");
        localStorage.setItem("ratibkapat", "");
        localStorage.setItem("hptachalu", "");
        localStorage.setItem("intrchalu", "");
        localStorage.setItem("sanghkchalu", "");
        localStorage.setItem("sanghkkapat", "");
        localStorage.setItem("retanchalu", "");
        localStorage.setItem("retankapat", "");
        localStorage.setItem("kapat1", "");
        localStorage.setItem("kapat2", "");
        localStorage.setItem("kapat3", "");
        localStorage.setItem("vahtuk", "");
        localStorage.setItem("comm", "");
        localStorage.setItem("ada", "");
        localStorage.setItem("billamt", "");

        props.setProgress(50);
        setTimeout(() => {
            props.setProgress(100);
        }, 200);

        navigate("/");
        // ✅ translated
        notify(t("common.logged_out"));
    }

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprint}
                data-bs-target="#printinput"
            >
            </button>

            <div className="modal fade" id="printinput" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprintclose} aria-label="Close">
                            </button>
                        </div>

                        <div className="modal-body">
                            <h5 className="modal-title" id="exampleModalLabel">{t("expiry.title")}</h5>
                            <span className='note'>{t("expiry.note")}</span>
                        </div>

                        <div className="expiry">
                            <span className='noteblue'>
                                {t("expiry.line1", { date: formatDate(localStorage.getItem("vdate")), days: daysRemaining })}
                            </span>
                            <span className='noteblue'>{t("expiry.line2")}</span>
                            <span className='noteblue'>{t("expiry.line3")}</span>
                            <span className='noteblue'>{t("expiry.line4")}</span>

                            <span className='noteblack'>{t("expiry.scan")}</span>

                            <img className='qrimg' src={qr} alt="" />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>
                                {t("expiry.btn_out")}
                            </button>
                            <button type="button" className="btn btn-danger" onClick={handleprintclose}>
                                {t("expiry.btn_ok")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='line' />

            {/* ✅ IMPORTANT: key forces remount on language change */}
            <div className="maincon" key={(i18n.resolvedLanguage || i18n.language)}>

                {/* ✅ Heading + Language Selector */}
                {mastermenu && (
                    <div className="dashHeaderRow">
                        <span className="heading1">{t("dash.title")}</span>
                        <LanguageSelector className="langChooserInline" />
                    </div>
                )}

                <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                    <Box action="member_master" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t1), var(--t1))"} head={t("dash.boxes.member_master")} img={<img src={farmer} alt="" />} />
                    <Box action="sangh_master" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t5dark), var(--t5dark))"} head={t("dash.boxes.sangh_master")} img={<img src={sanghicon} alt="" />} />
                    <Box action="ratib_customer" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t6dark), var(--t6dark))"} head={t("dash.boxes.ratib_customer")} img={<img src={ratib} alt="" />} />
                    <Box action="khadya_dealer" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"} head={t("dash.boxes.khadya_dealer")} img={<img src={khadya} alt="" />} />
                    <Box action="rate_sangh" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t1), var(--t1))"} head={t("dash.boxes.rate_sangh")} img={<img src={ratetable} alt="" />} />
                    <Box action="rate_kendra" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t3), var(--t3))"} head={t("dash.boxes.rate_kendra")} img={<img src={ratetable} alt="" />} />
                    <Box action="setting" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t4), var(--t4))"} head={t("dash.boxes.setting")} img={<img src={settings} alt="" />} />
                    <Box action="bank_master" setsubmenu={setsubmenu} visibility={visibility} background={"linear-gradient(179deg, var(--t3), var(--t3))"} head={t("dash.boxes.bank_master")} img={<img src={bank} alt="" />} />
                </div>

                <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
                    <div className="first"></div>
                    <div className="second">
                        <div className='line' />
                        <span className='firstspan'>{t("dash.info.p1")}</span>
                        <span className='infospan'>{t("dash.info.p2")}</span>
                        <span className='infospan'>{t("dash.info.p3")}</span>
                    </div>
                </div>

                <div className={`cust ${mastermenu ? 'hidden' : ''}`}>
                    {transitionEnded && showBackImage && (
                        submenu === "customer" ? <Newcustomer setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                            submenu === "sangh" ? <Sangh setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                submenu === "ratibmaster" ? <Ratibmaster setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                    submenu === "khparty" ? <Khparty setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                        submenu === "kendra" ? <Newkendra setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                            submenu === "ratetable" ? <Ratetable setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                submenu === "ratetablesangh" ? <Ratetablesangh setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                    submenu === "settings" ? <Setting setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                        submenu === "kapatmaster" ? <Kapatmaster setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                            submenu === "bank" ? <Bank setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                submenu === "nrepair" ? <Nrepair setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                    ""
                    )}
                </div>

            </div>

            <div className="secrow">
                <div className="leftsecrow"></div>
                {
                    submenu !== "ratetable" && submenu !== "ratetablesangh" && submenu !== "sangh" && submenu !== "ratibmaster" && submenu !== "khparty" && submenu !== "bank" && submenu !== "kapatmaster" && submenu !== "customer" && submenu !== "kendra" ?
                        <div className="imgcon">
                            <img className='imgcowdash' src={Cowleft} alt="" />
                        </div>
                        : ""
                }
            </div>

            {dialog.isLoading && (
                <Dialog
                    //Update
                    submessage={dialog.nameProduct}
                    onDialog={areUSure}
                    message={dialog.message}
                    functionname={openkendra}
                    button1text={t("dialog.no")}
                    button2text={t("dialog.yes")}
                />
            )}
        </>
    )
}

export default Dashcontendts
